import { FC } from 'react';
import { Text, TextProps } from '@chakra-ui/react';
import { RewardsActivityCardType } from '../../types/RewardsActivityCard';
import { formatDateTime } from '../../helpers';
export interface CbRewardsActivityCardDateProps extends TextProps {
  createdAt: RewardsActivityCardType['createdAt'];
}
export const CbRewardsActivityCardDate: FC<CbRewardsActivityCardDateProps> = ({
  createdAt,
  ...props
}) => {
  return <Text color="cloud.700" fontSize="sm" fontWeight="semibold" {...props} data-sentry-element="Text" data-sentry-component="CbRewardsActivityCardDate" data-sentry-source-file="CbRewardsActivityCardDate.tsx">
      {formatDateTime(createdAt)}
    </Text>;
};